import type { ErrorInfo, ReactNode } from 'react';

import { Component } from 'react';

import { MobileRedirectError } from './mobile-redirect-error';

import { RivaasError } from '@/errors/rivaas-error';

type State = {
  error: unknown;
  hasError: boolean;
};

export type MobileRedirectErrorBoundaryProps = {
  children: ReactNode;
  /** Omitted when `mobile_redirect` is not skippable per GET /info. */
  onContinueOnThisDeviceClick?: () => void;
};

export class MobileRedirectErrorBoundary extends Component<MobileRedirectErrorBoundaryProps, State> {
  public state: State = {
    hasError: false,
    error: undefined,
  };

  public static getDerivedStateFromError(error: unknown): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: unknown, errorInfo: ErrorInfo): void {
    this.logError(error, errorInfo);
  }

  private logError(error: unknown, errorInfo: ErrorInfo): void {
    if (error instanceof RivaasError) {
      error.log(errorInfo);
    } else {
      console.error(error, errorInfo);
    }
  }

  render() {
    const { hasError } = this.state;

    if (!hasError) {
      return this.props.children;
    }

    return <MobileRedirectError onContinueOnThisDeviceClick={this.props.onContinueOnThisDeviceClick} />;
  }
}
